import PropTypes from 'prop-types';
import { useFlightLive } from '@/hooks/useFlightLive';
import FlightLivePanel from './FlightLivePanel';

/**
 * Live status and insights for one leg of a trip (one booking slice), under
 * that leg in the trip page's Flight Details. The legs of a booking share
 * their requests (src/lib/flightStatusApi.js). Renders nothing while live
 * status is off or there's nothing to show.
 */
export default function FlightLegLive({ bookingId, sliceIndex }) {
  const { status, insights } = useFlightLive(bookingId);
  if (!status?.enabled && !insights?.enabled) return null;
  const forLeg = (data) => (data?.segments || []).filter((s) => sliceIndex == null || s.slice_index === sliceIndex);
  return <FlightLivePanel statusSegments={forLeg(status)} insightSegments={forLeg(insights)} nowMs={Date.now()} />;
}

FlightLegLive.propTypes = {
  bookingId: PropTypes.string,
  sliceIndex: PropTypes.number,
};
